<label for="1" class="form-required">{{ question }}</label>
<div>
  <div class="dcf-btn-group" data-toggle="buttons">
    @for (button of buttons; track button) {
      <label class="dcf-btn"
        [ngClass]="disabled == true? 'btn-disabled' : (val==button.value? 'dcf-btn-primary': 'dcf-btn-secondary')"
        (click)="value=button.value"
        (keydown)="isEnterKey($event, button.value)"
        uib-btn-radio="button.value"
        type="radio"
        tabindex="0"
        >{{ button.label }}
      </label>
    }
  </div>
</div>
<div [hidden]="val!='' || !required">
  <label class="error">This field is required.</label>
</div>